<template>
  <el-dialog
    v-model="bindPhoneVisible"
    title="���ֻ���"
    width="90%"
    :close-on-click-modal="false"
    @close="skipBindPhone"
  >
    <el-form :model="bindPhoneForm" :rules="bindPhoneRules" ref="bindPhoneFormRef">
      <el-form-item prop="phone">
        <el-input v-model="bindPhoneForm.phone" placeholder="�������ֻ�����" maxlength="11" clearable>
          <template #prefix><el-icon><Phone /></el-icon></template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <div class="verification-code">
          <el-input v-model="bindPhoneForm.code" placeholder="��������֤��" maxlength="6" clearable>
            <template #prefix><el-icon><Key /></el-icon></template>
          </el-input>
          <el-button type="primary" :disabled="bindCooldown > 0" @click="sendBindPhoneCode">
            {{ bindCooldown > 0 ? `${bindCooldown}�������` : '��ȡ��֤��' }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="skipBindPhone">�Ժ���˵</el-button>
      <el-button type="primary" :loading="bindPhoneLoading" @click="submitBindPhone">ȷ�ϰ�</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus'
import { Phone, Key } from '@element-plus/icons-vue'
import { setUserInfo } from '@/utils/auth'
import { sendSmsCode, getUserInfo, bindPhone } from '@/api/auth'
import {
  processWechatBindOAuthReturn,
  syncWechatBoundFlag,
  BIND_PHONE_PROMPT_EVENT
} from '@/utils/accountBind'

export default {
  name: 'AccountBindPrompt',
  components: { Phone, Key },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('�������ֻ�����'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('��������ȷ���ֻ�����'))
      } else {
        callback()
      }
    }
    return {
      bindPhoneVisible: false,
      bindPhoneLoading: false,
      bindCooldown: 0,
      bindPhoneForm: { phone: '', code: '' },
      bindPhoneMsgId: '',
      bindPhoneRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [
          { required: true, message: '��������֤��', trigger: 'blur' },
          { min: 6, max: 6, message: '��֤��Ϊ6λ����', trigger: 'blur' }
        ]
      },
      removeRouterHook: null
    }
  },
  mounted() {
    this.onBindPhonePrompt = () => {
      this.bindPhoneVisible = true
    }
    window.addEventListener(BIND_PHONE_PROMPT_EVENT, this.onBindPhonePrompt)
    this.processOAuthBindReturn()
    this.removeRouterHook = this.$router.afterEach(() => {
      this.$nextTick(() => this.processOAuthBindReturn())
    })
  },
  beforeUnmount() {
    window.removeEventListener(BIND_PHONE_PROMPT_EVENT, this.onBindPhonePrompt)
    if (this.removeRouterHook) {
      this.removeRouterHook()
    }
  },
  methods: {
    async processOAuthBindReturn() {
      await processWechatBindOAuthReturn()
    },
    sendBindPhoneCode() {
      this.$refs.bindPhoneFormRef.validateField('phone', (valid) => {
        if (!valid) return
        sendSmsCode(this.bindPhoneForm.phone).then(response => {
          const payload = response.data || {}
          if (!payload.msgId) {
            ElMessage.error('��֤�뷢��ʧ�ܣ�δ��ȡ�� msgId')
            return
          }
          this.bindPhoneMsgId = payload.msgId
          this.bindCooldown = 60
          const timer = setInterval(() => {
            this.bindCooldown--
            if (this.bindCooldown <= 0) clearInterval(timer)
          }, 1000)
          ElMessage.success(`��֤���ѷ����� ${this.bindPhoneForm.phone}`)
        }).catch(error => {
          ElMessage.error(error.message || '��֤�뷢��ʧ��')
        })
      })
    },
    submitBindPhone() {
      this.$refs.bindPhoneFormRef.validate((valid) => {
        if (!valid) return
        this.bindPhoneLoading = true
        bindPhone(this.bindPhoneForm.phone, this.bindPhoneForm.code, this.bindPhoneMsgId)
          .then(async () => {
            const userInfo = await getUserInfo()
            setUserInfo(userInfo)
            syncWechatBoundFlag(userInfo)
            this.bindPhoneVisible = false
            ElMessage.success('�ֻ��Ű󶨳ɹ�')
          })
          .catch(error => {
            ElMessage.error(error.message || '��ʧ��')
          })
          .finally(() => {
            this.bindPhoneLoading = false
          })
      })
    },
    skipBindPhone() {
      this.bindPhoneVisible = false
    }
  }
}
</script>

<style scoped>
.verification-code {
  display: flex;
  width: 100%;
}
.verification-code .el-input {
  flex: 1;
  margin-right: 10px;
}
.verification-code .el-button {
  width: 110px;
  font-size: 12px;
}
</style>
